import { HttpClient } from "@angular/common/http";
import { Component, Input, inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { LoaderService } from "@loader";
import { lastValueFrom } from "rxjs";

export enum ApiContentTypes {
    markdown = 'markdown',
    html = 'html'
}

@Component({
    selector: 'api-content-base',
    template: '',
    standalone: false
})
export abstract class ApiContentComponentBase {

    #loader: LoaderService = inject(LoaderService);

    #http: HttpClient = inject(HttpClient);

    #sanitizer: DomSanitizer = inject(DomSanitizer);

    #loaderId: number;

    isLoading: boolean = true;

    fragment: SafeHtml = null;

    abstract readonly fileUrl: string;

    @Input()
    type: ApiContentTypes = ApiContentTypes.html;

    public async ngAfterViewInit(){
        this.#loaderId = this.#loader.start();

        try {
            const data = await lastValueFrom(this.#http.get(this.fileUrl, { responseType: 'text'}));
            if(this.type === ApiContentTypes.html) {
                this.fragment = this.#sanitizer.bypassSecurityTrustHtml(data);
            }else {
                this.fragment = data;
            }
           
        } catch (e) {
            // ignored
        } finally {
            this.#loader.stop(this.#loaderId);
            this.isLoading = false;
        }
    }
}